// extracted by mini-css-extract-plugin
module.exports = {"CreateReference":"CreateReference_CreateReference__HBFW-","Dropzone":"CreateReference_Dropzone__1nnz3"};